import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoanResponse } from '@impact/data';

@Component({
    selector: 'app-loan-details-table',
    templateUrl: './loan-details-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoanDetailsTableComponent {
    @Input() loanData: LoanResponse;
}
